import { Card, Text, Group, Stack, UnstyledButton } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { IconChevronRight } from "@tabler/icons-react";

interface AdminSectionItem {
  label: string;
  path: string;
  count?: number;
}

interface AdminSectionCardProps {
  title: string;
  description: string;
  items: AdminSectionItem[];
  icon?: React.ReactNode;
  color?: string;
}

export default function AdminSectionCard({
  title,
  description,
  items,
  icon,
  color = "gcpBlue",
}: AdminSectionCardProps) {
  const navigate = useNavigate();

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Stack gap="md">
        <Group gap="sm">
          {icon && (
            <div style={{ color: `var(--mantine-color-${color}-6)` }}>
              {icon}
            </div>
          )}
          <div>
            <Text size="lg" fw={600}>
              {title}
            </Text>
            <Text size="sm" c="dimmed">
              {description}
            </Text>
          </div>
        </Group>

        <Stack gap={4}>
          {items.map((item) => (
            <UnstyledButton
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                transition: "background-color 0.2s",
              }}
              styles={(theme) => ({
                root: {
                  "&:hover": {
                    backgroundColor: theme.colors.gray[0],
                  },
                },
              })}
            >
              <Group justify="space-between">
                <Group gap="xs">
                  <Text size="sm" fw={500}>
                    {item.label}
                  </Text>
                  {item.count !== undefined && (
                    <Text size="xs" c="dimmed">
                      ({item.count})
                    </Text>
                  )}
                </Group>
                <IconChevronRight size={16} style={{ opacity: 0.5 }} />
              </Group>
            </UnstyledButton>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
}
